import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "./../../api/apiCaller";

export const GET_LIST_ARTICLE = "GET_LIST_ARTICLE";
export const GET_LIST_ARTICLE_ERROR = "GET_LIST_ARTICLE_ERROR";
export const GET_LIST_ARTICLE_SUCCESS = "GET_LIST_ARTICLE_SUCCESS";

export const COUNT_LIST_ARTICLE = "COUNT_LIST_ARTICLE";
export const COUNT_LIST_ARTICLE_ERROR = "COUNT_LIST_ARTICLE_ERROR";
export const COUNT_LIST_ARTICLE_SUCCESS = "COUNT_LIST_ARTICLE_SUCCESS";

export const ADD_NEW_ARTICLE = "ADD_NEW_ARTICLE";
export const ADD_NEW_ARTICLE_ERROR = "ADD_NEW_ARTICLE_ERROR";
export const ADD_NEW_ARTICLE_SUCCESS = "ADD_NEW_ARTICLE_SUCCESS";

export const EDIT_A_ARTICLE = "EDIT_A_ARTICLE";
export const EDIT_A_ARTICLE_SUCCESS = "EDIT_A_ARTICLE_SUCCESS";
export const EDIT_A_ARTICLE_ERROR = "EDIT_A_ARTICLE_ERROR";

export const DELETE_A_ARTICLE = "DELETE_A_ARTICLE";
export const DELETE_A_ARTICLE_SUCCESS = "DELETE_A_ARTICLE_SUCCESS";
export const DELETE_A_ARTICLE_ERROR = "DELETE_A_ARTICLE_ERROR";

export const OPENT_A_ARTICLE = "OPENT_A_ARTICLE";
export const OPENT_A_ARTICLE_SUCCESS = "OPENT_A_ARTICLE_SUCCESS";
export const OPENT_A_ARTICLE_ERROR = "OPENT_A_ARTICLE_ERROR";

export const SEARCH_ARTICLE = "SEARCH_ARTICLE";
export const SEARCH_ARTICLE_ERROR = "SEARCH_ARTICLE_ERROR";
export const SEARCH_ARTICLE_SUCCESS = "SEARCH_ARTICLE_SUCCESS";

/**
 * Reducer
 */

const initialState = {
  articles: [],
  error: false,
  count: 0,
  loading: false,
  aritcle: {},
  newArticle: [],
  keyword: "",
};

export const articlesReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_ARTICLE:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_ARTICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        articles: action.payload,
      };
    case GET_LIST_ARTICLE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };

    //count list
    case COUNT_LIST_ARTICLE:
      return {
        ...state,
        loading: true,
      };
    case COUNT_LIST_ARTICLE_SUCCESS:
      return {
        ...state,
        count: action.payload,
        loading: false,
      };
    case COUNT_LIST_ARTICLE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    //add new
    case ADD_NEW_ARTICLE:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_ARTICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        article: action.payload,
      };
    case ADD_NEW_ARTICLE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    //edit
    case EDIT_A_ARTICLE:
      return {
        ...state,
        loading: true,
      };
    case EDIT_A_ARTICLE_SUCCESS: {
      const newItems = state.articles.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        } else {
          return item;
        }
      });
      return {
        ...state,
        loading: false,
        articles: newItems,
      };
    }
    case EDIT_A_ARTICLE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    ///delete
    case DELETE_A_ARTICLE:
      return {
        ...state,
        loading: true,
      };
    case DELETE_A_ARTICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        article: action.payload,
      };
    case DELETE_A_ARTICLE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    //opent a article
    case OPENT_A_ARTICLE:
      return {
        ...state,
        loading: true,
      };
    case OPENT_A_ARTICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        article: action.payload,
      };
    case OPENT_A_ARTICLE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    //search article
    case SEARCH_ARTICLE:
      return {
        ...state,
        loading: true,
        keyword: action.data.keyword,
      };
    case SEARCH_ARTICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        newArticle: action.payload,
      };
    case SEARCH_ARTICLE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListArticle = (order, limit, skip, where) => ({
  type: GET_LIST_ARTICLE,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countListArticle = (where) => ({
  type: COUNT_LIST_ARTICLE,
  data: {
    where,
  },
});

export const addNewArticle = (
  title,
  icon,
  description,
  content,
  tags,
  topicId,
  isPublished,
  isNew
) => ({
  type: ADD_NEW_ARTICLE,
  data: {
    title,
    icon,
    description,
    content,
    tags,
    topicId,
    isPublished,
    isNew,
  },
});

export const editArticle = (
  id,
  title,
  icon,
  description,
  content,
  tags,
  topicId,
  isPublished,
  isNew
) => ({
  type: EDIT_A_ARTICLE,
  data: {
    id,
    title,
    icon,
    description,
    content,
    tags,
    topicId,
    isPublished,
    isNew,
  },
});

export const deleteArticle = (id) => ({
  type: DELETE_A_ARTICLE,
  data: {
    id,
  },
});

export const openAArticle = (id) => ({
  type: OPENT_A_ARTICLE,
  data: {
    id,
  },
});

export const searchArticle = (keyword) => ({
  type: SEARCH_ARTICLE,
  data: {
    keyword,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListArticle,
      countListArticle,
      addNewArticle,
      editArticle,
      deleteArticle,
      openAArticle,
      searchArticle,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListArticleApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/mini-crm/article", {
    order,
    limit,
    skip,
    ...where,
  });
};

const countListArticleApi = (where) => {
  return apiCaller.getData("/mini-crm/article/count", { ...where });
};
const addNewArticleApi = (
  title,
  icon,
  description,
  content,
  tags,
  topicId,
  isPublished,
  isNew
) => {
  return apiCaller.post("/mini-crm/article", {
    title,
    icon,
    description,
    content,
    ...tags,
    topicId,
    isPublished,
    isNew,
  });
};
const editArticleApi = (
  id,
  title,
  icon,
  description,
  content,
  tags,
  topicId,
  isPublished,
  isNew
) => {
  return apiCaller.put(`/mini-crm/article/${id}`, {
    title,
    icon,
    description,
    content,
    ...tags,
    topicId,
    isPublished,
    isNew,
  });
};
const deleteArticleApi = (id) => {
  return apiCaller.del(`/mini-crm/article/${id}`);
};

const openAArticleApi = (id) => {
  return apiCaller.getLogs(`/mini-crm/article/${id}`);
};

const searchArticleApi = (keyword) => {
  return apiCaller.getData(`/mini-crm/article/search`, { keyword });
};

/**
 * sagas
 */

export const getListArticleFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_ARTICLE);
    try {
      const res = yield call(
        getListArticleApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({ type: GET_LIST_ARTICLE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_LIST_ARTICLE_ERROR, error });
    }
  }
};

export const searchArticleFlow = function* () {
  while (true) {
    const action = yield take(SEARCH_ARTICLE);
    try {
      const res = yield call(searchArticleApi, action.data.keyword);
      yield put({ type: SEARCH_ARTICLE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: SEARCH_ARTICLE_ERROR, error });
    }
  }
};

export const countArticleFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_ARTICLE);
    try {
      const res = yield call(countListArticleApi, action.data.where);
      yield put({ type: COUNT_LIST_ARTICLE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: COUNT_LIST_ARTICLE_ERROR, error });
    }
  }
};

export const addNewArticleFlow = function* () {
  while (true) {
    const {
      data: {
        title,
        icon,
        description,
        content,
        tags,
        topicId,
        isPublished,
        isNew,
      },
    } = yield take(ADD_NEW_ARTICLE);
    try {
      const res = yield call(
        addNewArticleApi,
        title,
        icon,
        description,
        content,
        tags,
        topicId,
        isPublished,
        isNew
      );
      yield put({ type: ADD_NEW_ARTICLE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: ADD_NEW_ARTICLE_ERROR, error });
    }
  }
};

export const editArticleFlow = function* () {
  while (true) {
    const {
      data: {
        id,
        title,
        icon,
        description,
        content,
        tags,
        topicId,
        isPublished,
        isNew,
      },
    } = yield take(EDIT_A_ARTICLE);
    try {
      const res = yield call(
        editArticleApi,
        id,
        title,
        icon,
        description,
        content,
        tags,
        topicId,
        isPublished,
        isNew
      );
      yield put({ type: EDIT_A_ARTICLE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: EDIT_A_ARTICLE_ERROR, error });
    }
  }
};

export const deleteArticleFlow = function* () {
  while (true) {
    const action = yield take(DELETE_A_ARTICLE);
    try {
      const res = yield call(deleteArticleApi, action.data.id);
      yield put({ type: DELETE_A_ARTICLE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: DELETE_A_ARTICLE_ERROR, error });
    }
  }
};

export const openAArticleFlow = function* () {
  while (true) {
    const action = yield take(OPENT_A_ARTICLE);
    try {
      const res = yield call(openAArticleApi, action.data.id);
      yield put({ type: OPENT_A_ARTICLE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: OPENT_A_ARTICLE_ERROR, error });
    }
  }
};
